import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import {Button, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {AddConeButton} from './AddConeButton'

import {KilnPartDimensionsInputs} from '@kilnfeature/modules/kilnConfig/common'
import {useKilnConfig} from '@kilnfeature/providers'
import {KilnConfigActionType} from '@kilnfeature/types'

export const KilnShellConfigInputs = () => {
  const {t} = useTranslation()
  const {kilnLayout, dispatch} = useKilnConfig()

  const cones = kilnLayout.kilnShell.cones ?? []
  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center" spacing={2} mb={4}>
        <Typography variant="h3">{t('kilnConfig.kilnShellCones')}</Typography>
        <AddConeButton />
      </Stack>
      {cones.map((cone, index) => (
        <Stack key={cone.id} p={2} data-test-id={`cone-item-${index}`}>
          <Stack direction="row" alignItems="center" spacing={2} mb={4}>
            <Typography variant="h4">{`${t('kilnConfig.cone')} ${index + 1}`}</Typography>
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                dispatch({
                  type: KilnConfigActionType.REMOVE_CONE,
                  payload: {id: cone.id}
                })
              }}
              startIcon={<DeleteOutlineIcon />}
              data-test-id="cone-delete-btn"
            >
              {t('kilnConfig.delete')}
            </Button>
          </Stack>
          <KilnPartDimensionsInputs key={cone.id} selectedKilnPart={cone} showDiameter />
        </Stack>
      ))}
    </Stack>
  )
}
